// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc39ffe8","453":"5592044d","455":"ee78e0bb","977":"e343e5cf"}[chunkId] + ".chunk.js";
};